import DbTablesEdit from './DbTablesEdit';
import WebUniversal, { WebUniversalProps } from '../WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { useEffect, useRef } from 'react';
import { Switch } from 'antd';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';

const DbBackups = (props: any) => {
    /** api服务id */
    const apiId = 'dbTables';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    const { dbBackupsId } = data;

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '源表',
            dataIndex: 'sourceTableId',
        },
        {
            title: '目标表',
            dataIndex: 'targetTableId',
        },
        {
            title: '数据库备份',
            dataIndex: 'dbBackups',
            sorter: true,
            render: (text: any) => {
                if (text) {
                    const { backupName } = text;
                    return backupName;
                }
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '删除源表数据',
            dataIndex: 'isDeleteSourceTableData',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record['id']}
                />
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '数据表',
        apiId,
        columns,
        editOptions: {
            Editor: DbTablesEdit
        },
        sendPageData: { dbBackupsId }
    };

    return (
        <>
            <AntDraggableModal
                title={'数据表'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1080} >
                <WebUniversal {...extendProps} ref={ref} />
            </AntDraggableModal>

        </>
    )
}

export default DbBackups;
